export const createLogoMarker = (business, options = {}) => {
    const {
        highlighted = false,
        isDarkMode = false,
        defaultMarker = null,
        markerColor = '#FF5722', // Default color
        dealsColor = '#FF5722'   // Color for deals badge
    } = options;

    // Create the main container element
    const el = document.createElement('div');
    el.className = 'map-marker-container';
    el.style.cursor = 'pointer'; // Ensure pointer cursor

    // Add highlighted class if needed
    if (highlighted) {
        el.classList.add('marker-highlighted');
    }

    // Add dark mode class if needed
    if (isDarkMode) {
        el.classList.add('marker-dark');
    }

    // Add deals class if business has deals
    if (business.hasDeals) {
        el.classList.add('marker-has-deals');
    }

    // Create HTML for the deals badge if needed
    const dealsBadgeHTML = business.hasDeals
                           ? `<div class="marker-deals-badge">DEALS</div>`
                           : '';

    // Set initial HTML content
    el.innerHTML = `
        <div class="marker-pin"></div>
        <div class="marker-logo ${!business.logoImage ? 'svg-marker':''}">
            ${business.logoImage
              ? `<img src="${business.logoImage}" alt="${business.name}">`
              : '<div class="svg-placeholder"></div>'}
        </div>
        ${dealsBadgeHTML}
    `;

    // If no logo but we have a default marker, load the SVG
    if (!business.logoImage && defaultMarker) {
        // Find the placeholder
        const placeholder = el.querySelector('.svg-placeholder');

        // Fetch and insert the SVG
        fetch(defaultMarker)
            .then(response => response.text())
            .then(svgText => {
                // Parse the SVG
                const parser = new DOMParser();
                const svgDoc = parser.parseFromString(svgText, 'image/svg+xml');
                const svgElement = svgDoc.documentElement;

                // Apply styles to the SVG
                svgElement.setAttribute('width', '100%');
                svgElement.setAttribute('height', '100%');

                // Apply the color to all path, circle, rect elements
                const elements = svgElement.querySelectorAll('path, circle, rect, polygon');
                elements.forEach(element => {
                    element.setAttribute('fill', markerColor);
                    element.setAttribute('stroke', markerColor);
                });

                // Replace the placeholder with the SVG
                placeholder.innerHTML = '';
                placeholder.appendChild(svgElement);
            })
            .catch(error => {
                console.error('Error loading SVG:', error);
                placeholder.innerHTML = `<div class="marker-fallback" style="background-color: ${markerColor}"></div>`;
            });
    }

    return el;
};
